var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRightWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "15px",
    viewBox: "0 0 17 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboards-v1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard---Desktop",
    transform: "translate(-335.000000, -554.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search",
    transform: "translate(252.000000, 298.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Categories",
    transform: "translate(8.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button",
    transform: "translate(0.000000, 165.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.0444067,16.9770738 L91.0709433,16.9831322 L79.6953198,16.9831322 L83.2714003,13.2426288 C83.4465141,13.0600104 83.5425709,12.8126245 83.5425709,12.5529775 C83.5425709,12.2933305 83.4465141,12.0476756 83.2714003,11.8646245 L82.7149614,11.2835922 C82.5399858,11.1009738 82.3068232,11 82.058181,11 C81.8094006,11 81.5760998,11.1002526 81.4011243,11.282871 L75.2710362,17.6801401 C75.0953695,17.8634798 74.9993126,18.1076922 75,18.3674834 C74.9993126,18.6287172 75.0953695,18.8730738 75.2710362,19.056125 L81.4011243,25.4539711 C81.5760998,25.6364453 81.8092624,25.7368421 82.058181,25.7368421 C82.3068232,25.7368421 82.5399858,25.636301 82.7149614,25.4539711 L83.2714003,24.8729389 C83.4465141,24.690609 83.5425709,24.4471178 83.5425709,24.1874708 C83.5425709,23.9279681 83.4465141,23.697315 83.2714003,23.5148408 L79.654962,19.7534214 L91.0571222,19.7534214 C91.5694716,19.7534214 92,19.292548 92,18.7581079 L92,17.9363252 C92,17.4018851 91.5567562,16.9770738 91.0444067,16.9770738 Z",
    id: "Path",
    transform: "translate(83.500000, 18.368421) scale(-1, 1) translate(-83.500000, -18.368421) "
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightWhite);
export default __webpack_public_path__ + "static/media/arrow-right-white.db6cc01dfa4062013a9ebac155253534.svg";
export { ForwardRef as ReactComponent };